import type { StyleSpecification } from "@/types/style";

let idCounter = 0;

export function generateLayerId(prefix = "layer"): string {
  idCounter += 1;
  return `${prefix}-${idCounter}-${Date.now().toString(36)}`;
}

export function generateSourceId(prefix = "source"): string {
  idCounter += 1;
  return `${prefix}-${idCounter}-${Date.now().toString(36)}`;
}

/**
 * Returns the list of source IDs from a style.
 */
export function getSourceIds(style: StyleSpecification): string[] {
  return Object.keys(style.sources ?? {});
}

/**
 * Returns source-layer names for a given vector source.
 * Note: this requires tile data inspection which we can't do statically,
 * so we extract from layers that reference this source.
 */
export function getSourceLayerNames(
  style: StyleSpecification,
  sourceId: string,
): string[] {
  const names = new Set<string>();
  for (const layer of style.layers ?? []) {
    if ("source" in layer && layer.source === sourceId && "source-layer" in layer) {
      const sl = layer["source-layer"];
      if (typeof sl === "string") names.add(sl);
    }
  }
  return [...names];
}

/**
 * Moves a layer from one index to another in the layers array.
 */
export function reorderLayers(
  layers: StyleSpecification["layers"],
  fromIndex: number,
  toIndex: number,
): StyleSpecification["layers"] {
  const result = [...layers];
  const [moved] = result.splice(fromIndex, 1);
  if (moved) {
    result.splice(toIndex, 0, moved);
  }
  return result;
}
